import { Locales, withIntlProvider } from '@ratehub/base-ui';

import MESSAGES from '../definitions/EnglishMessages';


function withEnglishLocale(Component) {
    return withIntlProvider({
        Component,
        locale: Locales.ENGLISH,
        messages: MESSAGES,
    });
}

export default withEnglishLocale;
